import Navbar from "../components/Navbar";
import PageHero from "../components/PageHero";
import Stats from "../components/Stats";
import About from "../components/About";
import Services from "../components/Services";
import Process from "../components/Process";
import Gallery from "../components/Gallery";
import CuratedReviews from "../components/CuratedReviews";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import {
  SEO,
  localBusinessSchema,
  serviceSchema,
  faqSchema,
  breadcrumbSchema,
} from "../components/SEO";
import { BRAND } from "../mock";

const FAQS = [
  {
    q: "What's included in a full auto detail?",
    a: "Our full detail includes a foam wash, decontamination, clay treatment, light enhancement polish, full interior steam clean, leather conditioning, fabric extraction, glass polishing, tire dressing and a 6-month spray sealant. Pricing starts at $480.",
  },
  {
    q: "How much does auto detailing cost in Mississauga?",
    a: "At Jester Werks, interior detailing starts at $220, exterior detailing starts at $280, and full inside-out details start at $480. Larger SUVs and trucks are quoted accordingly. Free quotes within 24 hours.",
  },
  {
    q: "How long does a detail take?",
    a: "An interior detail takes 3 to 5 hours, an exterior detail takes 4 to 6 hours, and a full detail takes 6 to 9 hours. We're a small studio. every car gets one technician's full attention for the day.",
  },
  {
    q: "Do you remove pet hair and odors?",
    a: "Yes \u2014 we use specialized rubber tools, steam, and ozone treatment for severe pet hair and odor jobs. Add-on pricing applies depending on vehicle condition.",
  },
];

export default function AutoDetailingPage() {
  const url = `${BRAND.url}/auto-detailing-mississauga`;
  return (
    <div className="grain bg-jester-deep text-white">
      <SEO
        title="Auto Detailing Mississauga | Inside & Out | Jester Werks"
        description="Mississauga's boutique auto detailing studio. Steam-driven interior, hand-polished exterior, ceramic seal. From $220. 47+ five-star Google reviews. (647) 646-7223."
        canonical={url}
        schemas={[
          localBusinessSchema(),
          serviceSchema({
            name: "Auto Detailing Mississauga",
            description:
              "Full-service auto detailing in Mississauga \u2014 interior steam cleaning, exterior decontamination, paint enhancement and ceramic protection.",
            areaServed: ["Mississauga", "Toronto", "Oakville", "Brampton"],
            offers: "220",
          }),
          faqSchema(FAQS),
          breadcrumbSchema([
            { name: "Home", url: `${BRAND.url}/` },
            { name: "Auto Detailing Mississauga", url },
          ]),
        ]}
      />
      <Navbar />
      <PageHero
        kicker="Mississauga · Inside & Out"
        h1="AUTO"
        h1Accent="DETAILING."
        marker="better than the day you bought it."
        description="Steam-driven interior renewal, hand-polished exterior and an OEM-grade finish on every panel. Mississauga's most-reviewed boutique detail studio."
        city="Mississauga"
        bgImage="https://images.unsplash.com/photo-1583573278124-e8d4fd3edf3c"
      />

      <section className="relative py-24 md:py-28">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-acid mb-5 font-label">
           What we do
          </div>
          <h2 className="font-display text-4xl md:text-5xl leading-[1] mb-8">
            Boutique <span className="text-jester">auto detailing</span> in
            Mississauga.
          </h2>
          <div className="text-white/75 text-lg leading-relaxed space-y-5">
            <p>
              We're not a high-volume car wash. Jester Werks is a single-bay
              detail studio in Mississauga where{" "}
              <strong className="text-white">
                one car gets one full day
              </strong>{" "}
              of obsessive attention. Every interior gets steam-cleaned to
              factory levels. Every exterior gets a multi-step decontamination
              and hand polish.
            </p>
            <p>
              Whether you're prepping a vehicle for sale, recovering from a
              long winter, or just want it back to showroom. we'll quote you
              transparently and document the work end-to-end. Need long-term
              protection? Add a{" "}
              <a href="/ceramic-coating-mississauga" className="text-acid underline underline-offset-4 hover:text-white">
                ceramic coating
              </a>{" "}
              for years of effortless maintenance.
            </p>
          </div>
        </div>
      </section>

      <Stats />
      <Services />
      <About />
      <Process />
      <Gallery />
      <CuratedReviews />
      <FAQ items={FAQS} />
      <Contact />
      <Footer />
    </div>
  );
}
